import {
  Box,
  FormControl,
  FormControlLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  backSizeConverter,
  elbowSizeConverter,
} from "../../helpers/deviceSizes";
import { Option } from "../../types/option";
import { elbowMeasurementSystems } from "../../helpers/selectOptions";

export const ElbowSizeCalculator = () => {
  const { t } = useTranslation();
  const [measurement, setMeasurement] = useState<string>("0");
  const [size, setSize] = useState("");
  const [height, setHeight] = useState(0);
  const ref = useRef<HTMLInputElement>(null);

  const _onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setMeasurement(e.target.value);
  };
  const _handleInput = (e: ChangeEvent<HTMLInputElement>) => {
    let calculatedSize = elbowSizeConverter(
      e.target.value,
      parseInt(measurement)
    );
    setSize(calculatedSize ? calculatedSize : t("labels.size"));
  };

  useEffect(() => {
    if (ref.current && ref.current.clientHeight) {
      setHeight(ref.current.clientHeight);
    }
  }, []);

  return (
    <>
      <Stack direction={"row"} spacing={1}>
        <Stack width={"100%"} direction={"column"} spacing={1}>
          <TextField
            ref={ref}
            label={t("labels.circumference")}
            onChange={_handleInput}   
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  {elbowMeasurementSystems?.find(
                    (e: Option) => e && e.value === parseInt(measurement)
                  )?.label || "No matching option"}
                </InputAdornment>
              ),
            }}
          />
          <FormControl sx={{ height: height }}>
            <RadioGroup
              onChange={_onChange}
              row
              value={measurement}
              itemType="number"
            >
              {elbowMeasurementSystems.map((e) => {
                return (
                  <FormControlLabel
                    key={e.value}
                    value={e.value}
                    control={<Radio />}
                    label={e.label}
                  />
                );
              })}
            </RadioGroup>
          </FormControl>
        </Stack>
        <Stack
          width={"100%"}
          border={1}
          borderRadius={"4px"}
          alignItems={"center"}
          justifyContent="center"
        >
          <Typography fontSize={54}>
            {size === "" ? t("labels.size") : size}
          </Typography>
        </Stack>
      </Stack>
    </>
  );
};

export const BackSizeCalculator = () => {
  const { t } = useTranslation();
  // eslint-disable-next-line
  const [measurement, _] = useState(0);
  const [height, setHeight] = useState<string | null>(null);
  const [weight, setWeight] = useState<string | null>(null);
  const [size, setSize] = useState<string>(t("labels.size"));

  const handleHeight = (e: ChangeEvent<HTMLInputElement>) => {
    setHeight(e.target.value);
  };
  const handleWeight = (e: ChangeEvent<HTMLInputElement>) => {
    setWeight(e.target.value);
  };

  useEffect(() => {
    if (height && weight) {
      setSize(backSizeConverter(height, weight, measurement));
    }
    // eslint-disable-next-line
  }, [height, weight]);

  return (
    <>
      <Stack direction={"row"} spacing={1}>
        <Stack width={"100%"} direction={"column"} spacing={1}>
          <TextField
            label="Height"
            onChange={handleHeight}
           
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">cm</InputAdornment>
              ),
            }}
          />
          <TextField
            label="Weight"
            onChange={handleWeight}
           
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">kg</InputAdornment>
              ),
            }}
          />
        </Stack>
        <Stack
          border={1}
          borderRadius={"4px"}
          width={"100%"}
          alignItems={"center"}
          justifyContent="center"
        >
          <Box>
            <Typography fontSize={54}>{size}</Typography>
          </Box>
        </Stack>
      </Stack>
      <Stack>
        <FormControl>
          <RadioGroup row value={measurement} itemType="number">
            <FormControlLabel
              key={1}
              value={0}
              control={<Radio />}
              label={"Metric"}
            />
            <FormControlLabel
              disabled
              key={2}
              value={1}
              control={<Radio />}
              label={"Imperial"}
            />
          </RadioGroup>
        </FormControl>
      </Stack>
    </>
  );
};
